<template>
  <div>
    <h4>GitHub Info</h4>
    <b-table
      bordered
      outlined
      hover
      show-empty
      :items="info"
      :busy.sync="loadingResources"
    >
      <template #table-busy>
        <div>
          <b-spinner class="align-middle" />
          <strong>Loading...</strong>
        </div>
      </template>
      <template #empty>
        <div>
          GitHub resource information is unavailable
        </div>
      </template>
      <template #cell(url)="row">
        <a
          :href="row.value"
          target="_blank"
        >
          {{ row.value }}
        </a>
      </template>
    </b-table>

    <Repositories
      :project="project"
      :repositories="repositories"
      :archived-repositories="archivedRepositories"
      :loading-resources="loadingResources"
      @updated-repository="updateRepository"
      @archived-repository="archivedRepository"
    />

    <h4>
      GitHub Import Logs
      <font-awesome-icon
        id="finance-product-info-icon"
        v-b-hover="handleGithubImportInfoHover"
        icon="info-circle"
        :class="githubImportInfoHover ? 'text-muted pointer-cursor' : ''"
        @click="showGithubImportInfoModal"
      />
    </h4>
    <b-modal
      ref="githubImportInfoModal"
      title="GitHub Imports"
      hide-footer
      centered
    >
      <p>
        The import status does not indicate whether your team in AAD has been synchronized with
        GitHub. The first time you import a project, this may take up to 40 minutes even if the
        status says 'succeeded'.
      </p>
    </b-modal>
    <b-table
      bordered
      outlined
      hover
      show-empty
      :items="imports"
      :busy.sync="loadingImports"
    >
      <template #table-busy>
        <div>
          <b-spinner class="align-middle" />
          <strong>Loading...</strong>
        </div>
      </template>
      <template #empty>
        <div>
          GitHub import information is unavailable
        </div>
      </template>
      <template #cell(link)="row">
        <a
          :href="row.value"
          target="_blank"
        >
          {{ row.value }}
        </a>
      </template>
    </b-table>
  </div>
</template>

<script>
import api from '@/api';
import Repositories from '@/components/Repositories.vue';

export default {
  name: 'GitHubStatus',
  components: {
    Repositories,
  },
  props: {
    project: {
      type: Object,
      required: true,
      validator: (value) => !!value.projectName,
    },
  },
  data() {
    return {
      githubImportInfoHover: false,
      imports: [],
      loadingImports: false,
      loadingResources: false,
      pollingImports: null,
      pollingResources: null,
      info: [],
      repositories: [],
      archivedRepositories: [],
      resourceLoad: [],
    };
  },
  beforeDestroy() {
    clearInterval(this.pollingResources);
    clearInterval(this.pollingImports);
  },
  created() {
    // const refreshRateInMilliSeconds = 30000;
    // const self = this;
    this.getImports().then(() => {
      // self.pollingImports = setInterval(self.getImports, refreshRateInMilliSeconds);
    });
    this.getResources().then(() => {
      // self.pollingResources = setInterval(self.getResources, refreshRateInMilliSeconds);
    });
  },
  methods: {
    async getImports() {
      this.loadingImports = true;
      const response = await api.getGithubProjectImports(this.project.projectName);
      const newImports = [];
      response.forEach((item) => {
        if (!item.status) {
          item.status = 'unknown';
        }
        newImports.push(item);
      });
      this.imports = newImports;
      this.loadingImports = false;
    },
    async getResources() {
      this.loadingResources = true;
      this.repositories = [];
      this.archivedRepositories = [];
      try {
        const response = await api.getGithubProjectLinks(this.project.projectName);
        this.resourceLoad = response;
        this.$emit('getResourceLoad', this.resourceLoad);
        this.loadingResources = false;
        if (response) {
          this.info = [
            {
              item: 'Project',
              url: response.project,
            },
            {
              item: 'Team',
              url: response.team,
            },
          ];
          response.repositories.forEach((repo) => {
            const data = {
              name: `${repo.name}`,
              url: repo.url,
            };
            if (repo.archived) {
              this.archivedRepositories.push(data);
            } else {
              this.repositories.push(data);
            }
          });
        } else {
          this.info = [];
          this.repositories = [];
          this.archivedRepositories = [];
        }
      } catch (err) {
        this.loadingResources = false;
        this.info = [];
        this.repositories = [];
        this.archivedRepositories = [];
      }
    },
    handleGithubImportInfoHover(hovered) {
      this.githubImportInfoHover = hovered;
    },
    showGithubImportInfoModal() {
      this.$refs['githubImportInfoModal'].show();
    },
    updateRepository({updatedRepository, updates}) {
      for (const repository of this.repositories) {
        if (repository.name === updatedRepository.name && !this.inProgress) {
          repository.name = updates.name;
        }
      }
    },
    archivedRepository({name}) {
      let repo;
      for (let i = 0; i < this.repositories.length; i++) {
        if (this.repositories[i].name == name) {
          repo = this.repositories[i];
          this.repositories.splice(i, 1);
        }
      }
      this.archivedRepositories.push(repo);
    },
  },
};
</script>
